module.exports = __webpack_public_path__ + "img/3_141.759685d0.png";